import { userConstants } from '../constants/user.constants';

export function authInitialized(state = false, action) {
  switch (action.type) {
    case userConstants.AUTH_INITIALIZED:
    case userConstants.SET_CURRENT_USER:
    case userConstants.LOGOUT:
      return true;
    default:
      return state;
  }
}
